import React from 'react';

import useClasses from '../../../hooks/useClasses';
import CoreLink from '../../CoreLink';
import Icon from '../../Icon';

import './style.scss';

interface Props {
  heading: string;
  text: string;
  exercises: {
    title: string
    iconType: string
    url: string
    done: boolean
  }[];
  image?: string;
  completed: boolean;
}

const BlockProgramCompleted: React.FC<Props> = ({
  heading,
  text,
  exercises,
  image,
  completed,
}) => {
  const { buildClass, joinClasses } = useClasses('BlockProgramCompleted');

  if (!exercises.find(({ done }) => done)) {
    return null;
  }

  return (
    <div className={buildClass()}>
      {completed && (
        <>
          {image && (
            <div className={buildClass('image-container')}>
              <img src={image} alt="" />
            </div>
          )}
          <h2 className={buildClass('heading')}>
            {heading}
          </h2>
          <p className={buildClass('text')}>
            {text}
          </p>
        </>
      )}
      <div className={buildClass('exercises')}>
        {exercises.map((exercise) => (exercise.done && (
          <div className={buildClass('exercise')} key={`programCompletedExercises-${exercise.url}`}>
            <div className={buildClass('exercise-icon-container')}>
              <div className={buildClass('exercise-icon-container-inner')}>
                <Icon className={buildClass('exercise-icon')} icon={exercise.iconType} variant="2" size="md" />
              </div>
            </div>
            <CoreLink className={buildClass('exercise-url')} href={exercise.url}>
              <h3 className={joinClasses(buildClass('exercise-title'), 'asH5')}>
                {exercise.title}
              </h3>
            </CoreLink>
          </div>
        )))}
      </div>
    </div>
  );
};

export default BlockProgramCompleted;
